import mongoose from "mongoose"
import type { InferSchemaType } from "mongoose"


const { Schema, model } = mongoose

export { Schema, model, mongoose, type InferSchemaType }
export * from "./extendMongooseSchema"
export * from "./localizedStringField"
